"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QrCodeDialogController = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("../../components");
var _constantsGenerated = require("../../constants-generated");
var _defaultTranslations = require("../../constants/defaultTranslations");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _logger2 = require("../../logger");
var _ApiProvider = require("../ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve -- controller */

const logger = _logger2.mainLogger.createChild('QrCodeDialogController');
const onError = error => logger.error(new Error('TranslationsProvider fetching failed', {
  cause: error
}));
const QrCodeDialogController = ({
  translations
}) => {
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    data,
    initialOpenDone,
    onClose,
    open
  } = (0, _hooks.useQrCodeEvent)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.Presentation,
    project: _constantsGenerated.APP_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
          areaName: "QrCodeDialogController",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
            clientFetchConfiguration: initialOpenDone ? {
              baseUrl: staticApiUrl,
              onError,
              tenant
            } : undefined,
            defaultTranslationsWithNamespaces: {
              [_defaultTranslations.translationsNamespace]: _defaultTranslations.defaultTranslations
            },
            language: language,
            translationsWithNamespaces: translations ? {
              [_defaultTranslations.translationsNamespace]: translations
            } : undefined,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
              namespace: _defaultTranslations.translationsNamespace,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.QrCodeDialogProvider, {
                  ...data,
                  url: data?.url ?? '',
                  children: initialOpenDone ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.QrCodeDialog, {
                    open: open,
                    onClose: onClose
                  }) : null
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.QrCodeDialogController = QrCodeDialogController;
